module.exports = __webpack_public_path__ + "img/help-top.1b0840ec.png";